var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"5c74b62a0bfaccf0035c04ec9f91d9a69f1612c5"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/web/auth";

import * as Sentry from '@sentry/nextjs';

import { buildBeforeSend, ignoreErrors, isProd, resolveTracesSampleRate } from './sentry.shared';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_ENV,
  enabled: isProd,
  allowUrls: [/https?:\/\/.*jusbrasil\.com\.br/],
  denyUrls: [/^blob:/, /^chrome-extension:\/\//, /^moz-extension:\/\//, /^safari-extension:\/\//],
  ignoreErrors,
  beforeSend: buildBeforeSend({ isClient: true }),
  tracesSampler: (ctx) => resolveTracesSampleRate(ctx.name),
  debug: false,
});
